import { seoConfig, getCanonicalUrl } from '../../config/seo';

export default function JsonLd({ t, pathname }) {
  const pageUrl = getCanonicalUrl(pathname);

  const organization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Pixel Utility',
    url: seoConfig.parentBrandUrl,
    logo: `${seoConfig.siteUrl}/logo512.png`,
  };

  const webPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${pageUrl}#webpage`,
    url: pageUrl,
    name: t.meta.title,
    description: t.meta.description,
    isPartOf: {
      '@type': 'WebSite',
      '@id': `${seoConfig.siteUrl}/#website`,
      url: seoConfig.siteUrl,
      name: seoConfig.siteName,
      publisher: { '@id': `${seoConfig.parentBrandUrl}/#organization` },
    },
    about: {
      '@type': 'Thing',
      name: 'Clothing and shoe size conversion',
    },
    inLanguage: 'en',
  };

  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Pixel Utility',
        item: seoConfig.parentBrandUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Size Converter',
        item: pageUrl,
      },
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: t.faq.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  const appSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: t.hero.h1,
    description: t.meta.description,
    url: pageUrl,
    applicationCategory: 'UtilityApplication',
    operatingSystem: 'Any',
    browserRequirements: 'Requires JavaScript',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    provider: organization,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(webPage)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(appSchema)}</script>
    </>
  );
}
